import { useState, useEffect } from "react";
import PositionsTable from "./TaxHarvestingResultsTable";
import TaxHarvestingConsultHeader from "./TaxHarvestingConsultHeader";
import SecurityFilterDropdown from "./SecurityFilterDropdown";
import ResultTabs from "./resultTabs";
import TaxDueBreakdownSection from "./TaxDueBreakdownSection";


function TaxHarvestingResults({snapshot, lots}) {

  const [activeTab, setActiveTab] = useState("estimated_tax_open_positions");
  const [selectedTickers, setSelectedTickers] = useState([]);

  const [consultHeaderData, setConsultHeaderData] = useState({});
  const [securityDropdownOptions, setSecurityDropdownOptions] = useState({});

  const [openLots, setOpenLots] = useState([]);
  const [closedLots, setClosedLots] = useState([]);

  const [tableData , setTableData] = useState({});
  const [tableTotalsData, setTableTotalsData] = useState({});

  const [breakdownCardsData, setBreakdownCardsData] = useState({});

  useEffect(() => {
    if (!snapshot && !snapshot.length) return;

    preparedConsultHeaderData(snapshot);
    preparedSecurityDropdownData(snapshot);
    prepareBreakdownCardsData(snapshot)
    
  }, [snapshot])

  useEffect(() => {
    if (!Object.values(lots).length) return;
    setOpenLots(lots.open)
    setClosedLots(lots.closed)
  }, [lots])

  // const getTaxHarvestingLotsOpenSuccess = (data) => {
  //   setOpenLots(data.lots)
  // }
  // const getTaxHarvestingLotsOpenError = () => {
  //   console.log("LOTS OPEN error!")
  // }
  //
  // const getTaxHarvestingLotsCloseSuccess = (data) => {
  //   setClosedLots(data.lots)
  // }
  // const getTaxHarvestingLotsCloseError = () => {
  //   console.log("LOTS CLOSE error!")
  // }

  const preparedConsultHeaderData = (snapshot) => {
    const dateStart = snapshot.start_date;
    const dateEnd = snapshot.end_date;
    const clientName = snapshot.portfolio_name;
    const accountId = snapshot.id;

    setConsultHeaderData({
      dateStart,
      dateEnd,
      clientName,
      accountId
    }); 
  }
  const preparedSecurityDropdownData = (snapshot) => {
    const securities = snapshot.summary.presentation.securities.map(s => ({id: s.ticker_symbol, value: `${s.ticker_symbol}•${s.security}` }));
    setSelectedTickers(securities.map(s => s.id));
    setSecurityDropdownOptions(securities);
    setTableTotalsData(snapshot.summary.presentation.table_totals);
  }
  const prepareBreakdownCardsData = (snapshot) => {
    const cardsData = snapshot.summary.presentation.breakdown;
    setBreakdownCardsData(cardsData);
  }

  // Prepare table data with open and closed lots
  useEffect(() => {

    if (!openLots || !closedLots || !openLots.length || !closedLots.length) return;

     setTableData({
       estimated_tax_open_positions: openLots.map(l => l.display.calculated),
       open_positions: openLots.map(l => l.display.source),
       estimated_tax_closed_positions: closedLots.map(l => l.display.calculated),
       closed_positions: closedLots.map(l => l.display.source),
     })

  }, [openLots, closedLots])

  // Tickers present in the lots of the active tab
  const getLotTickers = (lots) =>
    lots
      .map((l) => l && l.display && l.display.calculated && l.display.calculated.Ticker)
      .filter(Boolean);

  // Keep one ticker visible, preferring one that exists in open AND closed lots
  const handleClearSelection = () => {
    const openTickers = getLotTickers(openLots);
    const closedTickers = getLotTickers(closedLots);
    const activeTickers = activeTab.includes("open") ? openTickers : closedTickers;
    const inAllTabs = selectedTickers.filter(
      (t) => openTickers.includes(t) && closedTickers.includes(t)
    );

    // keep the last one
    const keep =
      inAllTabs[0] ||
      selectedTickers.find((t) => activeTickers.includes(t)) ||
      activeTickers[0] ||
      selectedTickers[selectedTickers.length - 1];
    // setSelectedTickers([keep]);
    setSelectedTickers([]);
  };

  return (
    <div className="c-tax-harvesting-results">
      {Object.keys(consultHeaderData).length > 0 && (
        <TaxHarvestingConsultHeader {...consultHeaderData}  />
      )}
      { securityDropdownOptions.length > 0 && (
        <SecurityFilterDropdown
          securityDropdownOptions={securityDropdownOptions}
          selectedTickers={selectedTickers}
          onChange={setSelectedTickers}
          onClear={handleClearSelection}
        />
      )}
      <ResultTabs active={activeTab} onChange={setActiveTab} />

      {Object.keys(tableData).length > 0 && (
      <PositionsTable 
        activeTab={activeTab}
        openLots={openLots}
        closeLots={closedLots}
        tableData={tableData}
        totals={tableTotalsData}
        selectedTickers={selectedTickers}
      />
      )}

      {Object.keys(breakdownCardsData).length > 0 && (
        <TaxDueBreakdownSection
          openTaxDue={breakdownCardsData.open_tax_due_mxn}
          closedTaxDue={breakdownCardsData.closed_tax_due_mxn}
          openTaxDueMxn={breakdownCardsData.open_tax_loss_harvesting_mxn}
          closedTaxDueMxn={breakdownCardsData.closed_tax_loss_harvesting_mxn}
          onChange={(e) => console.log("from security => ",e)}
        />
      )}
    </div>
  );
}

export default TaxHarvestingResults;
